import { View } from "@react-pdf/renderer";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";
import { ResumePDFDescriptionBlackText, TemplateEightRightColumnSection } from "./common";

export const Skills = ({
  heading,
  skills,
  themeColor,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateEightRightColumnSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescriptionBlackText items={descriptions} />
      </View>
    </TemplateEightRightColumnSection>
  );
};
